module.exports = __webpack_public_path__ + "img/qiyewangzhan.838abc0c.png";